import React from 'react';
import { autobind } from 'core-decorators';
import { Row, Col, Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import {
  PontoControleEditForm,
  schema,
} from 'src/paginas/gestao-risco/ponto-controle/edit';
import { Form } from 'src/utils/form';
import { capitalizeFirstLetter } from 'src/utils/string';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import EditDialog from 'src/componentes/edit/edit-dialog';
import Tab from 'src/componentes/tabs/tab';
import Tabs from 'src/componentes/tabs/tabs';
import Input from 'src/componentes/input';
import Panel from 'src/componentes/panel';
import PontoControleLookup from 'src/lookups/ControleLookup';
import StatusLookup from 'src/lookups/status-risco-ponto-controle';
import { COLUNAS } from 'src/utils/constants';

import Schema from './RiscoPontoControleSchema';
import { getConfiguration } from 'src/services/commonRequests';
import ContentManager from 'src/componentes/content-manager';
import Confirm from 'src/componentes/message-box/confirm';
import { lowerCaseAllLetter } from 'src/utils/string';
import InputNumber from 'src/componentes/input-number';
import { Alert } from 'reactstrap';
import { FUNCAO_CONTROLE } from 'src/paginas/gestao-risco/constants/BeltConstants';
import { Label } from 'src/componentes/Form';
import Checkbox from 'src/componentes/checkbox';
import Info from 'src/componentes/info';
import ReactTooltip from 'react-tooltip';
import { formatNumberWithSeparators } from 'src/utils/number';
import CustomInput from 'src/componentes/CustomInput';

const RevisaoPontoControleListView = React.lazy(() =>
  import(
    'src/paginas/gestao-risco/risco/RevisaoPontoControle/RevisaoPontoControleListView'
  )
);
const EfetividadeControleView = React.lazy(() =>
  import(
    'src/paginas/gestao-risco/risco/RevisaoPontoControle/EfetividadeControle/EfetividadeControleView'
  )
);
const IndicadoresRiscoControleView = React.lazy(() =>
  import(
    'src/paginas/gestao-risco/ponto-controle/controle-indicador-risco/view'
  )
);

const TabLoading = (
  <div
    style={{
      minHeight: 200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Spinner color="primary" />
  </div>
);

@autobind
class RiscoPontoControleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configuracao: {},
      configuracaoRisco: {},
      alterouEfetividade: false,
    };
  }

  componentDidMount() {
    getConfiguration('PontoControleConfiguracao')((configuracao) =>
      this.setState({ configuracao: configuracao })
    )();
    getConfiguration('ItemConfiguracaoRisco')((configuracaoRisco) =>
      this.setState({ configuracaoRisco: configuracaoRisco })
    )();
  }

  handleChangePontoControle(value) {
    if (value == null) {
      this.props.model.getModel('periodicidade').requestChange(null);
      this.props.model.getModel('responsaveis').requestChange(null);
      this.props.model.getModel('anexoObrigatorio').requestChange(null);
      this.props.model.getModel('diasToleranciaRevisao').requestChange(null);
      this.props.model.getModel('tipoTolerancia').requestChange(null);
      this.props.model.getModel('calendario').requestChange(null);
      this.props.model.getModel('tipoEvidencias').requestChange(null);
    } else {
      this.props.model
        .getModel('periodicidade')
        .requestChange(value.periodicidade);
      this.props.model
        .getModel('responsaveis')
        .requestChange(value.responsaveis);
      this.props.model
        .getModel('anexoObrigatorio')
        .requestChange(value.anexoObrigatorio);
      this.props.model
        .getModel('diasToleranciaRevisao')
        .requestChange(value.diasToleranciaRevisao);
      this.props.model
        .getModel('tipoTolerancia')
        .requestChange(value.tipoTolerancia);
      this.props.model.getModel('calendario').requestChange(value.calendario);
      this.props.model
        .getModel('tipoEvidencias')
        .requestChange(value.tipoEvidencias);
    }

    this.props.model.getModel('pontoControle').requestChange({
      id: value?.id,
      descricao: value?.descricao,
      agrupador: value?.agrupador,
    });
  }

  setChangeEfetividade() {
    this.setState({ alterouEfetividade: true });
  }

  closeModal(closeModalChild) {
    this.props.handleCloseEdit &&
      this.props.handleCloseEdit(false, closeModalChild);
  }

  pesoHabilitado() {
    return this.props.model.getModel('pesoHabilitado').value;
  }

  parsePeso(value) {
    if (value == null || value === '') return 0;

    const numberValue = Number(value);
    if (!isNaN(numberValue)) return numberValue;

    const { decimalSeparator, thousandsSeparator } = this.props;
    let normalizedValue = value.toString();
    if (thousandsSeparator) {
      normalizedValue = normalizedValue.split(thousandsSeparator).join('');
    }
    if (decimalSeparator) {
      normalizedValue = normalizedValue.split(decimalSeparator).join('.');
    }

    const parsedValue = Number(normalizedValue);
    return isNaN(parsedValue) ? 0 : parsedValue;
  }

  formatPeso(value) {
    const { decimalSeparator, thousandsSeparator } = this.props;

    return formatNumberWithSeparators(
      value,
      2,
      decimalSeparator,
      thousandsSeparator
    );
  }

  requestChangeTipos(tipo) {
    const { model } = this.props;
    let tiposModel = model.getModel('tiposSelecionados').value;

    if (!tiposModel) {
      tiposModel = [];
    }

    var tipoSelecionado = tiposModel.find((t) => t.id === tipo.id);

    if (!tipoSelecionado) {
      tipoSelecionado = {
        id: tipo.id,
        descricao: tipo.descricao,
        value: true,
      };
      tiposModel.push(tipoSelecionado);
    } else {
      tipoSelecionado.value = !tipoSelecionado.value;
    }
    model.getModel('tiposSelecionados').requestChange(tiposModel);
  }

  getValueTipo(tipo) {
    const { model } = this.props;

    if (!model.getModel('aplicarEfetividadeAoTipo')?.value) return false;

    const tiposModel = model.getModel('tiposSelecionados').value;
    if (tiposModel) {
      var tipoSelecionado = tiposModel.find((t) => t.id == tipo.id);
      return tipoSelecionado ? tipoSelecionado.value : false;
    }
    return false;
  }

  render() {
    let { model, intl, resources, disabled, currenttabIndex, parameters } =
      this.props;
    let id = model.getModel('id').value;
    const isNew = !id || id == 0;
    const idPontoControle = model.getValue('pontoControle')?.id;

    const isDisabled = disabled
      ? disabled
      : model && !model.getModel('permissions').getModel('allowEdit').value;

    let tipos = [];
    const pontoControleEditForm = new Form({
      component: this,
      schema: schema,
      model: model.getModel('pontoControleEdit').value,
    });

    if (!currenttabIndex) currenttabIndex = 0;

    const funcao =
      model?.getModel('pontoControleEdit')?.value?.funcaoPontoControle;
    const pesoTotal =
      isNew && this.state.configuracao?.avaliarEfetividadeControleSeparadamente
        ? funcao?.id === FUNCAO_CONTROLE.CORRETIVO
          ? model.getModel('pesoTotalCorretivo').value
          : model.getModel('pesoTotalPreventivo').value
        : model.getModel('pesoTotal').value || 0;

    const controleCorretivo = funcao?.id === FUNCAO_CONTROLE.CORRETIVO;
    const controlePreventivo =
      !controleCorretivo && funcao?.id === FUNCAO_CONTROLE.PREVENTIVO;

    if (controleCorretivo) {
      tipos = model.getModel('tiposSeveridade')?.value || [];
    } else if (controlePreventivo) {
      tipos = model.getModel('tiposProbabilidade')?.value || [];
    }

    const statusControleId = model.getModel('status')?.value?.id;
    const controleAtivo = statusControleId === 1;
    const controleEncerrado = statusControleId === 2;
    const pesoItem = controleAtivo
      ? this.parsePeso(model.getModel('peso').value)
      : 0;
    const pesoDistribuido = Number(
      (this.parsePeso(pesoTotal) + pesoItem).toFixed(2)
    );
    const charCount = model?.getModel('descricao')?.value
      ? model.getModel('descricao').value.length
      : 0;
    return (
      <Tabs currenttabIndex={currenttabIndex}>
        <Tab key="1" label={intl.formatMessage({ id: 'label.resumo' })}>
          <Panel>
            <Row>
              <Col md={5}>
                <PontoControleLookup
                  disabled={isDisabled || id > 0}
                  model={{
                    label: capitalizeFirstLetter(resources.pontodecontrole),
                    value: model.getModel('pontoControle').value,
                    requestChange: this.handleChangePontoControle,
                    errors: model.getModel('pontoControle').errors,
                  }}
                  data={{
                    riscoId: parameters.riscoId,
                    todosTipos: false,
                    pontoControleId: idPontoControle,
                  }}
                  required
                />
              </Col>

              {this.pesoHabilitado() && (
                <Col md={3}>
                  <InputNumber
                    disabled={
                      isDisabled ||
                      model.getModel('pontoControle')?.value?.agrupador
                    }
                    precision={2}
                    symbolEnd="%"
                    style={{ height: '38px' }}
                    model={{
                      label: intl.formatMessage({ id: 'peso' }) + ' (%)',
                      value: model.getModel('peso').value,
                      requestChange: model.getModel('peso').requestChange,
                      errors: model.getModel('peso').errors,
                    }}
                  />
                </Col>
              )}
              <Col md={3}>
                <StatusLookup
                  disabled={isDisabled}
                  model={model.getModel('status')}
                  required
                />
              </Col>
              {id > 0 && (
                <Col md={1}>
                  <ArquivoUploadAnexos
                    tipoAnexo={this.props.tiposAnexos.riscoPontoControle}
                    formGroupStyle={{ marginBottom: 0 }}
                    model={model.getModel('arquivos')}
                  />
                </Col>
              )}
            </Row>
            {this.pesoHabilitado() && !isNew && controleEncerrado && (
              <Row>
                <Col md={12}>
                  <Alert color="warning">
                    <p>
                      {intl.formatMessage(
                        {
                          id: 'msgControleEncerradoNaoConsideradoCalculoPeso',
                        },
                        {
                          pontodecontrole: lowerCaseAllLetter(
                            resources.pontodecontrole
                          ),
                        }
                      )}
                    </p>
                  </Alert>
                </Col>
              </Row>
            )}
            {this.pesoHabilitado() &&
              !controleEncerrado &&
              (!isNew || funcao) &&
              pesoDistribuido != 100 && (
                <Row>
                  <Col md={12}>
                    <Alert color="warning">
                      <p>
                        {funcao?.id === FUNCAO_CONTROLE.PREVENTIVO
                          ? intl.formatMessage(
                              {
                                id: 'msgValidacaoAtencaoPesoTodosControlesNaoTotalizam100Preventivo',
                              },
                              { pontosdecontrole: resources.pontosdecontrole }
                            ) +
                            ' ' +
                            this.formatPeso(pesoDistribuido) +
                            '%'
                          : intl.formatMessage(
                              {
                                id: 'msgValidacaoAtencaoPesoTodosControlesNaoTotalizam100Corretivo',
                              },
                              { pontosdecontrole: resources.pontosdecontrole }
                            ) +
                            ' ' +
                            this.formatPeso(pesoDistribuido) +
                            '%'}
                      </p>
                    </Alert>
                  </Col>
                </Row>
              )}
            <Row>
              <Col md={12}>
                <Input
                  rows={2}
                  type="textarea"
                  disabled={isDisabled}
                  model={model.getModel('descricao')}
                  maxLength={300}
                />
                <span>
                  {intl.formatMessage(
                    { id: 'labelMsgQtdadeCaracteresNome' },
                    { charCount: charCount }
                  )}
                </span>
              </Col>
            </Row>
          </Panel>

          {!isNew &&
            !model.getModel('pontoControle')?.value?.agrupador &&
            !model.getModel('probabilidadeCalculadaPorFormula')?.value &&
            this.state.configuracao?.avaliarEfetividadeControle &&
            this.state.configuracao?.aplicarEfetividadeConformeTipos && (
              <>
                <Panel
                  id="panelEfetividadeTipo"
                  data-tip
                  data-for="tooltipPanelEfetividadeTipo"
                  header={intl.formatMessage(
                    { id: 'labelEfetividadeApliacadaFuncaoControle' },
                    { pontodecontrole: resources.pontodecontrole }
                  )}
                  headerStyle={
                    (!controleCorretivo && !controlePreventivo) || isDisabled
                      ? { opacity: 0.5, color: '#60717d' }
                      : { opacity: 1 }
                  }
                >
                  <Row>
                    <Col className="d-flex inline" md={12}>
                      {(controleCorretivo || controlePreventivo) && (
                        <Label className="mr-2">
                          {controleCorretivo
                            ? intl.formatMessage(
                                {
                                  id: 'labelHabilitarEfetividadeAplicadaTipoSeveridade',
                                },
                                { severidade: resources.severidade }
                              )
                            : intl.formatMessage(
                                {
                                  id: 'labelHabilitarEfetividadeAplicadaTipoProbabilidade',
                                },
                                { probabilidade: resources.probabilidade }
                              )}
                        </Label>
                      )}
                      {(controleCorretivo || controlePreventivo) && (
                        <CustomInput
                          type="switch"
                          id={`switch-visible-subprojects`}
                          name="customSwitch"
                          disabled={isDisabled || !tipos || tipos.length === 0}
                          checked={
                            model.getModel('aplicarEfetividadeAoTipo')?.value &&
                            tipos &&
                            tipos.length > 0
                          }
                          onChange={() => {
                            model
                              .getModel('aplicarEfetividadeAoTipo')
                              .requestChange(
                                !model.getModel('aplicarEfetividadeAoTipo')
                                  .value
                              );
                          }}
                        />
                      )}
                      <Info
                        className="ml-2"
                        text={intl.formatMessage(
                          {
                            id: controlePreventivo
                              ? 'hintHabilitarEfetividadePorTipoRiscoControleProbabilidade'
                              : 'hintHabilitarEfetividadePorTipoRiscoControleSeveridade',
                          },
                          {
                            severidade: resources.severidade,
                            probabilidade: resources.probabilidade,
                            pontodecontrole: resources.pontodecontrole,
                          }
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-2 pl-2">
                    {tipos &&
                      tipos.map((tipo) => (
                        <Col key={tipo.id} md={3}>
                          <Checkbox
                            styleLabel={{ fontWeight: 'bold' }}
                            disabled={
                              !model.getModel('aplicarEfetividadeAoTipo')
                                ?.value || isDisabled
                            }
                            model={{
                              label: tipo.nome,
                              value: this.getValueTipo(tipo),
                              requestChange: (value) =>
                                this.requestChangeTipos(tipo, value),
                            }}
                          />
                        </Col>
                      ))}
                  </Row>
                </Panel>
                <ReactTooltip
                  id="tooltipPanelEfetividadeTipo"
                  aria-haspopup="true"
                  disable={
                    /*controleCorretivo || controlePreventivo || */ tipos &&
                    tipos.length > 0
                  }
                >
                  {!controleCorretivo && !controlePreventivo
                    ? intl.formatMessage(
                        {
                          id: 'msgFuncaoControleNaoDefinidaParaHabilitarEfetividadePorTipo',
                        },
                        {
                          severidade: resources.severidade,
                          probabilidade: resources.probabilidade,
                          pontodecontrole: resources.pontodecontrole,
                        }
                      )
                    : !tipos || tipos.length === 0
                    ? intl.formatMessage(
                        {
                          id: 'hintCadastrarTiposParaAplicarEfetividadeConformeSelecao',
                        },
                        {
                          tipocontrole: controleCorretivo
                            ? resources.severidade
                            : resources.probabilidade,
                        }
                      )
                    : null}
                </ReactTooltip>
              </>
            )}

          {id > 0 && (
            <Panel
              header={
                <FormattedMessage
                  id="pontoControle"
                  values={{
                    pontodecontrole: capitalizeFirstLetter(
                      resources.pontodecontrole
                    ),
                  }}
                />
              }
            >
              <PontoControleEditForm
                model={pontoControleEditForm.getModel()}
                resources={resources}
                setChangeEfetividade={this.setChangeEfetividade}
                intl={intl}
                disabled={isDisabled}
                showConfirmMsg={true}
                showRevisoesControle={false}
                riscoControleView={true}
              />
            </Panel>
          )}
        </Tab>
        {id > 0 && (
          <Tab
            key="2"
            label={intl.formatMessage(
              { id: 'label.revisaoPontoControle' },
              { revisaodecontrole: resources.revisaodecontrole }
            )}
          >
            <React.Suspense fallback={TabLoading}>
              <RevisaoPontoControleListView
                id={id}
                tag={COLUNAS.RISCO_REVISOES_PONTO_CONTROLE}
                disabled={isDisabled ? isDisabled : false}
                showDelete={isDisabled ? false : true}
                showNew={isDisabled ? false : true}
                showTitle={false}
                idRiscoPontoControle={id}
                parameters={{
                  idRisco: parameters.riscoId,
                  idRiscoPontoControle: id,
                }}
              />
            </React.Suspense>
          </Tab>
        )}
        {id > 0 &&
          this.state.configuracao &&
          this.state.configuracao.avaliarEfetividadeControle && (
            <Tab
              key="3"
              label={intl.formatMessage(
                { id: 'efetividadeControle' },
                { pontodecontrole: resources.pontodecontrole }
              )}
            >
              <React.Suspense fallback={TabLoading}>
                <EfetividadeControleView
                  funcaoControle={
                    pontoControleEditForm &&
                    pontoControleEditForm.getModel('funcaoPontoControle') &&
                    pontoControleEditForm.getModel('funcaoPontoControle').value
                  }
                  alterouEfetividade={this.state.alterouEfetividade}
                  riscoControleId={id}
                  disabled={isDisabled ? isDisabled : false}
                  showDelete={isDisabled ? false : true}
                  showNew={isDisabled ? false : true}
                />
              </React.Suspense>
            </Tab>
          )}
        {id > 0 &&
          this.state.configuracaoRisco &&
          this.state.configuracaoRisco.habilitarIndicadoresRisco &&
          model.getModel('pontoControleEdit').getModel('tipoDeControle')
            .value &&
          model.getModel('pontoControleEdit').getModel('tipoDeControle').value
            .id == 2 && (
            <Tab
              label={intl.formatMessage(
                { id: 'indicadorRisco' },
                { risco: resources.risco }
              )}
              key="4"
            >
              <React.Suspense fallback={TabLoading}>
                <IndicadoresRiscoControleView
                  controleId={idPontoControle}
                  closeModal={this.closeModal}
                />
              </React.Suspense>
            </Tab>
          )}
      </Tabs>
    );
  }
}

class RiscoPontoControleEdit extends React.Component {
  handleConfirmeBeforeSave(
    item,
    handleSave,
    intl,
    fechar,
    resources,
    modelInicial,
    showErrors,
    afterSave
  ) {
    if (item && item.pontoControle && item.pontoControle.agrupador) {
      const msgId =
        item.pontoControle.totalFilhos <= 1
          ? 'msgVinculacaoAgrupadorControlesRiscoSingular'
          : 'msgVinculacaoAgrupadorControlesRisco';
      ContentManager.addContent(
        <Confirm
          message={intl
            .formatMessage(
              { id: msgId },
              {
                pontosdecontrole: lowerCaseAllLetter(
                  resources.pontosdecontrole
                ),
                pontodecontrole: lowerCaseAllLetter(resources.pontodecontrole),
                risco: lowerCaseAllLetter(resources.risco),
              }
            )
            .replaceAll('{totalfilhos}', `${item.pontoControle.totalFilhos}`)}
          handleConfirm={() => {
            handleSave(fechar);
          }}
        />
      );
    } else {
      handleSave(fechar);
      afterSave && afterSave();
    }
  }

  render() {
    const { resources, parameters } = this.props;

    return (
      <EditDialog
        url="/RiscoPontoControle"
        title={capitalizeFirstLetter(resources.pontodecontrole)}
        parameters={parameters}
        formComponent={RiscoPontoControleForm}
        schema={Schema}
        width="85%"
        maxHeight="93%"
        handleConfirmeBeforeSave={this.handleConfirmeBeforeSave}
        resources={resources}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    tiposAnexos: state.user.tiposAnexos,
    decimalSeparator: state.user.decimalSeparator,
    thousandsSeparator: state.user.thousandsSeparator,
  };
}
export default injectIntl(connect(mapStateToProps)(RiscoPontoControleEdit));
